import { render, staticRenderFns } from "./MaterialRecord.vue?vue&type=template&id=8d611ede&scoped=true"
import script from "./MaterialRecord.vue?vue&type=script&lang=js"
export * from "./MaterialRecord.vue?vue&type=script&lang=js"
import style0 from "./MaterialRecord.vue?vue&type=style&index=0&id=8d611ede&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d611ede",
  null
  
)

export default component.exports